export default {"src":"/_next/static/media/potatochips.0ab801f7.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};